import React, { Component } from 'react';
import OrderListPaged from '../Orders/OrderListPaged';
import Content from './Content';

export default class Dashboard extends Component {
  state = { activeTab: 'orders' };

  render() {
    const { activeTab } = this.state;
    return (
      <div>
        <div className="dashboard-tabs">
          <div className="nav nav-tabs" role="tablist" aria-label="Dashboard">
            <button type="button" id="daily-orders-tab" role="tab"
              className={'nav-link' + (activeTab === 'orders' ? ' active' : '')}
              aria-selected={activeTab === 'orders'} aria-controls="daily-orders-panel"
              onClick={() => this.setState({ activeTab: 'orders' })}>Orders</button>
            <button type="button" id="summary-tab" role="tab"
              className={'nav-link' + (activeTab === 'summary' ? ' active' : '')}
              aria-selected={activeTab === 'summary'} aria-controls="summary-panel"
              onClick={() => this.setState({ activeTab: 'summary' })}>Summary</button>
          </div>
        </div>
        {activeTab === 'orders' ? (
          <div role="tabpanel" id="daily-orders-panel" aria-labelledby="daily-orders-tab">
            <OrderListPaged dailyDashboard />
          </div>
        ) : (
          <div role="tabpanel" id="summary-panel" aria-labelledby="summary-tab">
            <Content />
          </div>
        )}
      </div>
    );
  }
}
